import React, {Component} from "react";
import {Col, Grid, Row} from "react-bootstrap";
import {Redirect} from "react-router";
import Card from "../../components/Card/Card";
import {DataRedisCacheManagement} from "../../components/Middleware/DataRedisCacheManagement";
import dev from "../../assets/img/data.png";

class RedisCacheManagement extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect: false
        }
    }

    cancelRedisCacheManagement() {
        this.setState({redirect: true});
    }

    renderRedirect = () => {

        if (this.state.redirect) {
            return <Redirect push to={"/settings"}/>
        }

    }

    render() {
        return (
            <div className="main-content">
                {this.renderRedirect()}

                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <Card
                                content={
                                    <Grid fluid>
                                        <Row>
                                            <Col sm={12}>
                                                <div className="center">
                                                    <img className="img-responsive center-block"
                                                         style={{maxHeight: '56px', maxWidth: '100%'}}
                                                         src={dev}
                                                         alt={"redis-cache-management"}
                                                    />
                                                    <h4 style={{marginTop: '18px', marginBottom: '6px'}}>
                                                        Redis Cache Management
                                                    </h4>
                                                    <p className="category" style={{marginBottom: 0}}>
                                                        Inspect, search and manage Redis cache across the configured middleware servers.
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Grid>
                                }
                            />
                        </Col>
                    </Row>

                    <DataRedisCacheManagement
                        onBack={this.cancelRedisCacheManagement.bind(this)}
                    />
                </Grid>
            </div>
        )
    }
}

export default RedisCacheManagement;
